import moment from 'moment';
import {isEmpty, isNumber} from 'lodash';
import {noTimeZoneLongISODate, reverseShortDate} from '../common/constants/datesFormat';
import {errorFields} from './errorFields';

export const processFiles = (files) => {
  const formData = new FormData();
  files.forEach((element) => {
    const name = element.name;
    formData.append('file', element, name);
  });
  return formData;
};

export const validateUnique = (arr, field, value) => {
  const searchElement = arr.find((item) => item[field] === value);
  return typeof(searchElement) === 'undefined' ? true : false;
};

export const getSearchOptions = (list = [], fieldUsedLikeValue) => {
  return list.map((element, index) => {
    const title = (element[fieldUsedLikeValue] || '').replace(',', '.');
    return {title, 'key': index};
  });
};

export const updateFormData = (filters, formData) => {
  const {
    bulletinId,
    type,
    model,
    katashiki,
    subject,
    symptom,
    cause,
    fix,
    createdDate,
    countermeasure,
    production,
    partsInfo,
    petition,
    parts,
  } = filters;
  let generalInfo = {
    model,
    katashiki,
    subject,
  };

  if (type !== 'TMC') {
    generalInfo = {
      ...generalInfo,
      symptom,
      cause,
      fix,
      countermeasure,
      production,
      partsInfo,
      petition,
    };
  }

  formData.append('createdDate', moment(createdDate, reverseShortDate).format(noTimeZoneLongISODate));
  formData.append('generalInfo', JSON.stringify(generalInfo));
  formData.append('bulletinId', bulletinId);
  formData.append('type', type);
  formData.append('parts', JSON.stringify(parts));
  return formData;
};

const validateFieldsForm = (bulletinFields, errorFields) => {
  let error = {
    'field': '',
    'error': false,
  };
  const errorArr = Object.keys(errorFields);
  errorArr.forEach((errorName) => {
    const field = bulletinFields[errorName];
    const selectField = isNumber(field) && isNaN(field) === false ? `${field}` : field;
    if (isEmpty(selectField)) {
      error = {
        'field': errorFields[errorName],
        'error': true,
      };
    }
  });
  return error;
};

export const validateErrors = (data) => {
  const {type} = data;
  const fieldsForm = errorFields(type);
  const validateForm = validateFieldsForm(data, fieldsForm);
  if (validateForm.error) {
    return {
      'error': true,
      'message': `El campo ${validateForm.field} es requerido`,
    };
  }
  return {
    'error': false,
    'message': null,
  };
};

export const bulletinSectionTypes = (id, isUserFromTDE) => {
  const types = {
    'generalInfo': 'INFORMACION GENERAL',
    'attachments': 'ADJUNTOS',
    'parts': 'PARTES',
  };

  if (id && isUserFromTDE) {
    types.record = 'HISTORIAL';
  }

  return types;
};
